import React from 'react';
import {
  Box,
  Button,
  Container,
  Flex,
  HStack,
  Image,
  Link,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Text,
} from '@chakra-ui/react';
import { Link as RouterLink } from 'react-router-dom';
import { MdLanguage } from 'react-icons/md';
import { useUserState } from 'context/UserContext';
import { useTranslation } from 'i18n';

// Navbar tối giản cho landing: logo bên trái, link/CTA + language toggle bên phải.
// User đã login → "Vào Dashboard"; chưa login → "Đăng nhập" (system nội bộ,
// tài khoản do admin cấp — không có public sign-up).
export default function SiteHeader() {
  const { isAuthenticated } = useUserState();
  const { lang, setLang, t } = useTranslation();

  return (
    <Box
      as="header"
      borderBottom="1px solid"
      borderColor="gray.100"
      bg="white"
      position="sticky"
      top={0}
      zIndex={10}
      backdropFilter="saturate(180%) blur(8px)"
    >
      <Container maxW="container.xl" px={{ base: 4, md: 6 }}>
        <Flex h={{ base: '60px', md: '64px' }} align="center" justify="space-between">
          <RouterLink to="/">
            <HStack spacing={2.5} cursor="pointer">
              <Image
                src="/android-chrome-192x192.png"
                alt="Social Panel"
                boxSize={{ base: '28px', md: '32px' }}
                borderRadius="8px"
              />
              <Text fontWeight={700} fontSize={{ base: 'md', md: 'lg' }} color="gray.800">
                Social Panel
              </Text>
            </HStack>
          </RouterLink>

          <HStack spacing={{ base: 2, md: 6 }}>
            <HStack spacing={5} display={{ base: 'none', md: 'flex' }}>
              <Link href="#platforms" fontSize="sm" color="gray.600" _hover={{ color: 'blue.500' }}>
                {t('header.nav.platforms')}
              </Link>
              <Link href="#features" fontSize="sm" color="gray.600" _hover={{ color: 'blue.500' }}>
                {t('header.nav.features')}
              </Link>
              <Link
                href="#how-it-works"
                fontSize="sm"
                color="gray.600"
                _hover={{ color: 'blue.500' }}
              >
                {t('header.nav.howItWorks')}
              </Link>
              <Link href="#contact" fontSize="sm" color="gray.600" _hover={{ color: 'blue.500' }}>
                {t('header.nav.contact')}
              </Link>
              <Link
                as={RouterLink}
                to="/legal"
                fontSize="sm"
                color="gray.600"
                _hover={{ color: 'blue.500' }}
              >
                {t('header.nav.legal')}
              </Link>
            </HStack>

            <Menu placement="bottom-end">
              <MenuButton
                as={Button}
                size="sm"
                variant="ghost"
                color="gray.600"
                _hover={{ color: 'blue.500', bg: 'gray.50' }}
                borderRadius="full"
                px={{ base: 2, md: 3 }}
                leftIcon={<MdLanguage />}
                aria-label={t('header.lang.label')}
              >
                <Text fontSize="sm" fontWeight={600} textTransform="uppercase">
                  {lang}
                </Text>
              </MenuButton>
              <MenuList minW="140px" py={1}>
                <MenuItem
                  fontSize="sm"
                  onClick={() => setLang('vi')}
                  fontWeight={lang === 'vi' ? 700 : 400}
                  color={lang === 'vi' ? 'blue.500' : 'gray.700'}
                >
                  {t('header.lang.vi')}
                </MenuItem>
                <MenuItem
                  fontSize="sm"
                  onClick={() => setLang('en')}
                  fontWeight={lang === 'en' ? 700 : 400}
                  color={lang === 'en' ? 'blue.500' : 'gray.700'}
                >
                  {t('header.lang.en')}
                </MenuItem>
              </MenuList>
            </Menu>

            {isAuthenticated ? (
              <Button
                as={RouterLink}
                to="/admin/dashboard"
                size="sm"
                colorScheme="blue"
                borderRadius="full"
                px={5}
              >
                {t('header.cta.dashboard')}
              </Button>
            ) : (
              <Button
                as={RouterLink}
                to="/auth/sign-in"
                size="sm"
                colorScheme="blue"
                borderRadius="full"
                px={5}
              >
                {t('header.cta.signIn')}
              </Button>
            )}
          </HStack>
        </Flex>
      </Container>
    </Box>
  );
}
